import { CheckBox } from "@mui/icons-material";
import { Box, Button, Checkbox, CircularProgress, Dialog, DialogActions, Stack, Typography, colors } from "@mui/material";
import { grey, yellow } from "@mui/material/colors";
import { DataGrid } from "@mui/x-data-grid";
import axios from "axios";
import { GlobalState } from "context/GlobalContext";
import { PimDashboardState } from "context/PimDashboardContext";
import {
	converAttrToDatagridCol,
	imageTableColumn,
	styleImageColumn,
	statusOptions,
	publishColumns,
	inputTypes,
} from "data/globalData";
import { attrGroupLinkedTables, constraintsOptions, productionStageOptions, styleColorAssocObj } from "components/PimDashboard/data";
import moment from "moment";
import { useEffect, useState } from "react";
import { AuthState } from "context/AuthContext";
import { allowAccess } from "utils/userAccessFun";
import { custom, departments } from "data/authData";
import { parseErrorMessage } from "utils/ErrorFunctions/parseErrorMessage";
import { sourcingOptionCogsColumn } from "components/PimDashboard/DashboardComponents/Sourcing/FabricStylesDashboard/EditFabricStyleDetails/data";

const colStyle = {
	headerAlign: "center",
	align: "center",
};

const PublishModal = ({ modal, setModal, submitFunction, styleData, setStyleData }) => {
	const { snackBar, setSnackBar, setSnackBarOpen } = GlobalState();
	const { setLoadingOpen } = GlobalState();
	const { setSelectedStyle, allAttributes } = PimDashboardState();
	const { user } = AuthState();
	const [styleFullData, setStyleFullData] = useState();
	const [loading, setLoading] = useState();

	const colorTableColumns = [
		imageTableColumn(styleImageColumn),
		...allAttributes
			?.filter((row) => row.linked_table === attrGroupLinkedTables.color.key)
			.map((row) => converAttrToDatagridCol(row)),
		{
			field: "publish",
			headerName: "Publish",
			width: 100,
			...colStyle,
			renderCell: ({ row }) => {
				console.log(row, "dfsedf");
				return (
					<Box display="flex" alignItems="center" justifyContent="center" width="100%" height="100%">
						<Checkbox
							color="success"
							disabled={row?.is_published || row?.rejected}
							checked={row?.publish ? true : false}
							onChange={(e) => handleColorPublishCheckbox(e.target.checked, row)}
						/>
					</Box>
				);
			},
		},
		{
			field: "reject",
			headerName: "Reject",
			width: 100,
			...colStyle,
			renderCell: ({ row }) => {
				return (
					<Box display="flex" alignItems="center" justifyContent="center" width="100%" height="100%">
						<Checkbox
							color="warning"
							disabled={row?.is_published || row?.rejected}
							checked={row?.reject ? true : false}
							onChange={(e) => handleColorRejectCheckbox(e.target.checked, row)}
						/>
					</Box>
				);
			},
		},

		// {
		// 	// field: "pallette",
		// 	headerName: "Delete",
		// 	width: 60,
		// 	...colStyle,
		// 	renderCell: (params) => {
		// 		return (
		// 			<IconButton onClick={(e) => handleBarcodeDeleteClick(e, params.row)}>
		// 				<DeleteRounded />
		// 			</IconButton>
		// 		);
		// 	},
		// },
	];

	useEffect(() => {
		const fetch = async () => {
			setLoading(true);
			try {
				const res = await axios.get(`/api/designer/style_by_id/${styleData?.style_id}`);
				setPendingAttrs(returnPendingRequiredFields(res.data));

				setColorsToPublish(res.data?.[attrGroupLinkedTables.color.key]);
				setStyleFullData(res.data);
				setLoading(false);
			} catch (error) {
				console.log(error, "sdfjghdsjs");
				setSnackBarOpen(true);
				setSnackBar({ ...snackBar, severity: "error", message: parseErrorMessage(error) });
			}
		};
		if (styleData?.style_id) fetch();
	}, [styleData]);
	const [colorsToPublish, setColorsToPublish] = useState([]);
	const [pendingAttrs, setPendingAttrs] = useState([[]]);

	const handleColorPublishCheckbox = (checked, gridRow) => {
		console.log(gridRow, "gridPublish");
		setColorsToPublish(
			colorsToPublish?.map((row) => {
				if (gridRow.id === row.id) {
					if (checked)
						return {
							...row,
							publish: true,
							reject: false,
						};
					else return { ...row, publish: false };
				} else return row;
			}),
		);
	};

	const handleColorRejectCheckbox = (checked, gridRow) => {
		console.log(checked);
		setColorsToPublish(
			colorsToPublish?.map((row) => {
				if (gridRow.id === row.id) {
					if (checked)
						return {
							...row,
							reject: true,
							publish: false,
						};
					else return { ...row, reject: false };
				} else return row;
			}),
		);
	};

	const handleCloseModal = () => {
		setModal(false);
		setColorsToPublish([]);
		setStyleData();
	};

	const returnPendingRequiredFields = (styleDetails) => {
		let pendingFields = [];
		allAttributes
			.filter((row) => row.linked_table !== attrGroupLinkedTables.color.key && row.group_id !== "fabric_details")
			.forEach((atrr) => {
				if (atrr.constraints[constraintsOptions.NOTNULL.key] === true) {
					if (!styleDetails[atrr.linked_table][atrr.key]) pendingFields.push(atrr);
					else if (
						atrr.input_type === inputTypes.MULTIPLE_SELECT.key &&
						styleDetails[atrr.linked_table][atrr.key].length === 0
					) {
						pendingFields.push(atrr);
					} else if (
						atrr.input_type === inputTypes.SELECT.key &&
						(styleDetails[atrr.linked_table][atrr.key] === "" ||
							styleDetails[atrr.linked_table][atrr.key] === inputTypes.SELECT.key)
					) {
						pendingFields.push(atrr);
					}
				}
			});
		styleDetails?.[attrGroupLinkedTables.color.key]?.forEach((colorRow) => {
			allAttributes
				.filter(
					(row) => row.linked_table === attrGroupLinkedTables.color.key && ![sourcingOptionCogsColumn.key].includes(row.key),
				)
				.forEach((atrr) => {
					if (atrr.constraints[constraintsOptions.NOTNULL.key] === true) {
						if (!colorRow[atrr.key]) {
							pendingFields.push(atrr);
						} else if (atrr.input_type === inputTypes.MULTIPLE_SELECT.key && colorRow[atrr.key].length === 0) {
							pendingFields.push(atrr);
						} else if (
							atrr.input_type === inputTypes.SELECT.key &&
							(colorRow[atrr.key] === "" || colorRow[atrr.key] === inputTypes.SELECT.key)
						) {
							pendingFields.push(atrr);
						}
					}
				});
		});

		// remove duplicates
		pendingFields = Object.values(
			pendingFields.reduce((acc, row) => {
				{
					acc[row.key] = row;
					return acc;
				}
			}, {}),
		);

		return pendingFields;
	};

	const handleFormSubmit = async (status) => {
		setLoadingOpen(true);

		const pendingFields = returnPendingRequiredFields(styleFullData);

		if (pendingFields.length) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: `Please Fill the values for ${pendingFields.map((row) => row.name).join(",")}`,
				severity: "warning",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoadingOpen(false);

			return;
		}

		let pendingArr = colorsToPublish?.reduce((acc, row) => {
			if (!row.publish && !row.reject && status !== statusOptions.REJECTED.key) acc.push(row);
			return acc;
		}, []);
		if (pendingArr?.length) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: `Approve or Reject the following Colors -- ${pendingArr?.map((row) => row.color)} `,
				severity: "warning",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoadingOpen(false);

			return;
		}
		const sysData = {
			last_updated_by: user?.email,
			published_by: user?.email,
			published_date: moment().format("YYYY-MM-DD"),
			stage: status === statusOptions.PUBLISHED.key ? productionStageOptions.BUYING.key : productionStageOptions.DESIGNER.key,
		};
		let updatedColorArr = colorsToPublish?.map((row) => {
			row = {
				...row,
				status:
					row?.publish === true && status === statusOptions.PUBLISHED.key
						? statusOptions.SOURCING_PENDING.key
						: statusOptions.REJECTED.key,
				...sysData,
			};
			delete row["reject"];
			delete row["publish"];
			return row;
		});
		console.log(updatedColorArr, "asfasdf");
		const body = {
			...styleData,
			published_date: moment().format("YYYY-MM-DD"),
			...sysData,
			status: status === statusOptions.PUBLISHED.key ? statusOptions.SOURCING_PENDING.key : statusOptions.REJECTED.key,
		};
		try {
			const res = await axios.put("/api/designer/publish_style_with_color", {
				...body,
				[styleColorAssocObj]: updatedColorArr,
			});
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: "Style Published ",
				severity: "success",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
			setLoadingOpen(false);
			if (typeof submitFunction === "function") submitFunction(body, res.data);
		} catch (error) {
			setSnackBarOpen(true);
			setSnackBar({ ...snackBar, severity: "error", message: parseErrorMessage(error) });
			setLoadingOpen(false);
		}
	};

	return (
		<Dialog fullWidth maxWidth="md" open={modal} onClose={handleCloseModal} component="form">
			{loading ? (
				<Box width="100%" height={300} display="flex" justifyContent="center" alignItems="center">
					<CircularProgress />
				</Box>
			) : (
				<Box
					width="95%"
					margin="auto"
					pt={2}
					display="flex"
					flexWrap="wrap"
					columnGap={2}
					rowGap={1}
					// justifyContent="space-around"
				>
					<Typography width="100%" variant="h6">
						PUBLISH STYLE
					</Typography>
					<Box display="flex" columnGap="3%" width="100%">
						<img
							style={{
								width: `100px`,
								height: `120px`,
								objectFit: "cover",
								objectPosition: "50% 0%",
								borderRadius: 2,
							}}
							src={styleData?.[styleImageColumn.key] ?? ""}
						/>
						<Box display="flex" flexWrap="wrap" columnGap={1} rowGap={1} height={90}>
							{allAttributes
								?.filter((row) => row.linked_table === attrGroupLinkedTables.style.key)
								?.map((column) => {
									return (
										<Box display="flex" columnGap="3px" width="30%">
											<Typography>{column.name} :</Typography>
											<Typography fontSize={18} color={grey[800]} fontWeight={600}>
												{styleData?.[column.key] ?? "----"}
											</Typography>
										</Box>
									);
								})}
						</Box>
					</Box>

					<Stack width="94%" minHeight={200} pt={2}>
						<Typography variant="h6">Select Colors </Typography>

						<DataGrid
							key={colors}
							rows={colorsToPublish ? colorsToPublish : []}
							columns={colorTableColumns}
							sx={{
								minHeight: 200,
								maxHeight: 300,
								border: "none",
								"& .MuiDataGrid-row": {
									// borderBottom: "1px solid lightgray",
									cursor: "pointer",
									border: "none",
								},
								"& .MuiDataGrid-cell": {
									display: "flex",
									alignItems: "Center",
								},
								"& .MuiDataGrid-columnHeader": {
									cursor: "pointer",
								},
								"& .MuiDataGrid-columnHeaders": {
									background: grey[300],
									border: "none",
									borderRadius: 1,
									// padding: "10px 0px",
								},
							}}
							columnHeaderHeight={35}
							rowHeight={60}
							hideFooter
							// showCellVerticalBorder
							// onRowClick={(params, e) => handleStyleSelect(params.row)}
							initialState={{
								pagination: {
									paginationModel: { pageSize: 10 },
								},
							}}
							// isRowSelectable={(params) => params.row.is_published === false}
							disableRowSelectionOnClick
							pageSizeOptions={[10, 50]}
							// checkboxSelection
						/>
					</Stack>

					{pendingAttrs.length > 0 && (
						<Typography color={colors.orange[800]} fontWeight={600} width="100%">
							Pending Required Fields: {pendingAttrs.map((row) => row.name).join(", ")}
						</Typography>
					)}

					<DialogActions sx={{ marginLeft: "auto" }}>
						<Button variant="outlined" onClick={handleCloseModal}>
							Cancel
						</Button>
						<Button
							autoFocus
							variant="contained"
							color="error"
							onClick={() => handleFormSubmit(statusOptions.REJECTED.key)}
							disabled={
								colorsToPublish?.length === 0 ||
								!allowAccess(custom.STYLE_PUBLISHER.key, user, departments.DESIGNER.key)
							}>
							Reject Style
						</Button>
						<Button
							autoFocus
							variant="contained"
							sx={{ mr: 1 }}
							onClick={() => handleFormSubmit(statusOptions.PUBLISHED.key)}
							disabled={
								colorsToPublish?.length === 0 ||
								!allowAccess(custom.STYLE_PUBLISHER.key, user, departments.DESIGNER.key) ||
								pendingAttrs.length > 0
							}>
							Publish
						</Button>
					</DialogActions>
				</Box>
			)}
		</Dialog>
	);
};

export default PublishModal;
